// src/servicerequests/edit.js

import React from 'react';
import {
  Edit,
  ReferenceInput,
  SelectInput,
  FileInput,
  FileField,
  DateInput,
  SimpleForm,
  BooleanInput,
  TextInput,
  maxLength,
  required,
  SaveButton,
  Toolbar,
  TextField,
} from "react-admin";
import { useServicePermissions, SERVICE_STATUS, transformData } from "./utils";

const CustomToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const ServiceRequestForm = () => {
  const { isServiceRole, canEditStatus, canEditSpareParts } =
    useServicePermissions();

  return (
    <>
      <TextInput source="id" label="ID del Pedido" disabled />

      <TextField source="service.name" label="Servicio Técnico" />

      <ReferenceInput
        label="Producto"
        source="product.id"
        reference="products"
        perPage={1000}
        sort={{ field: "code", order: "ASC" }}
        disabled={isServiceRole}
      >
        <SelectInput optionText="fullName" validate={[required()]} />
      </ReferenceInput>

      <DateInput
        source="purchaseDate"
        validate={[required()]}
        options={{
          maxDate: new Date(),
          locale: "es-ES",
        }}
        label="Fecha de Compra"
        disabled={isServiceRole}
      />

      <FileInput
        source="invoiceImage"
        label="Factura"
        accept="image/*,application/pdf"
        placeholder={<p>Adjuntar Foto de la Factura (Campo obligatorio)</p>}
        validate={[required()]}
        disabled={isServiceRole}
        options={{
          preventDropOnDocument: true,
          allowRemove: !isServiceRole,
        }}
        format={value => {
          if (!value) return [];
          if (Array.isArray(value)) {
            return value.map(v => {
              if (typeof v === 'string') {
                return { src: v, title: v.split('/').pop().split('?')[0] };
              }
              if (v && v.src) {
                return { ...v, title: v.title || v.src.split('/').pop().split('?')[0] };
              }
              return v;
            });
          }
          if (typeof value === 'string') {
            return [{ src: value, title: value.split('/').pop().split('?')[0] }];
          }
          if (value && value.src) {
            return [{ ...value, title: value.title || value.src.split('/').pop().split('?')[0] }];
          }
          return [];
        }}
      >
        <FileField source="src" title="title" target="_blank" />
      </FileInput>

      <TextInput
        source="productStatus"
        validate={[required()]}
        label="Estado del Producto"
        disabled={isServiceRole}
      />

      {canEditSpareParts && (
        <>
          <BooleanInput source="needsSpareParts" label="¿Necesita Repuestos?" disabled={isServiceRole} />
          <TextInput
            source="sparePartsDetail"
            label="Detalles de Repuestos"
            multiline
            disabled={isServiceRole}
          />
        </>
      )}

      <TextInput source="comments" label="Observaciones" multiline disabled={isServiceRole} />

      <TextInput
        source="clientFirstName"
        validate={[required(), maxLength(100)]}
        label="Nombre del Cliente"
        disabled={isServiceRole}
      />

      <TextInput
        source="clientLastName"
        validate={[required(), maxLength(100)]}
        label="Apellido del Cliente"
        disabled={isServiceRole}
      />

      <TextInput
        source="clientEmail"
        validate={[required()]}
        label="Email del Cliente"
        disabled={isServiceRole}
      />

      <SelectInput
        source="status"
        choices={Object.entries(SERVICE_STATUS).map(([key, value]) => ({
          id: value,
          name: value,
        }))}
        label="Estado del Pedido"
        disabled={isServiceRole}
      />
    </>
  );
};

export const ServiceRequestEdit = () => {
    return (
        <Edit
            actions={null}
            transform={transformData}
            mutationMode="pessimistic"
        >
            <SimpleForm
                toolbar={<CustomToolbar />}
                defaultValues={{
                    status: SERVICE_STATUS.PENDING
                }}
            >
                <ServiceRequestForm />
            </SimpleForm>
        </Edit>
    );
};